// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.47_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./vars.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/cjs.js??clonedRuleSet-14.use[1]!../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.4.47_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-14.use[2]!./utils.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*general css*/
html {
  overflow: auto;
  font-size: 62.5%;
}
body,
.application {
  font-size: 1.4rem;
  line-height: 2rem;
  height: 100%;
  font-family: 'Noto Sans', Avenir, Helvetica, Arial, sans-serif !important;
}
a {
  text-decoration: none;
}
.v-tooltip__content {
  background: #414141;
}
textarea {
  resize: none;
}
.bg-gray {
  background-color: #fafafa !important;
}
.input-group--hide-details .input-group__details {
  min-height: 2px;
  padding: 0;
}
table.v-table tbody td {
  font-size: 14px;
}
.obj-fit-cover {
  object-fit: cover;
}
.bg-white {
  background-color: #fff;
}
.img-responsive {
  max-width: 100%;
}
.text-green {
  color: #4caf50;
}
.text-orange {
  color: #ff9800;
}
.text-secondary {
  color: #c9004b;
}
.text-gray-primary {
  background-color: #607d8c !important;
}
.question-title-desc {
  clear: both;
}
.overflowHidden {
  overflow: hidden !important;
}
.fullScreen {
  position: fixed !important;
  height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
  top: 0;
  left: 0;
  z-index: 3 !important;
}
.google-map-street-view .widget-scene-canvas {
  height: 100% !important;
  width: 100% !important;
}
.gm-fullscreen-control {
  display: none !important;
}
.toolbar--clipped {
  z-index: 8;
}
.fullScreenIconFixedStyle {
  position: fixed !important;
  top: 80px !important;
}
.hide {
  display: none;
}
.fullScreenIcon {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 4;
  cursor: pointer;
  background-color: #ffffff;
}
.v-dialog .v-card {
  width: 100%;
}

/*Grid Style*/
.gridView {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.title-divider {
  height: 2px;
}
.gridView th {
  text-align: left;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 20px;
  padding: 0 10px 0 0 !important;
}
.gridView th:first-child {
  padding-left: 24px !important;
}
.gridView th:first-child,
.gridView th:last-child {
  border: inherit;
  border-color: #ccc;
}
.gridView table.v-table tbody td:not(:first-child) {
  padding: 0 10px 0 0 !important;
}
.gridView .v-datatable__progress th {
  padding: 0px !important;
}
.gridView .icon-hover .v-icon {
  cursor: pointer;
}
.gridView .v-datatable__actions__select .v-select {
  max-width: 48px;
}
.gridView .v-datatable__actions {
  flex-wrap: nowrap !important;
}

/* Incoming call style */
@keyframes spaceboots {
  0% {
    transform: translate(2px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(0px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(2px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(2px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}

/*Vue-bar Scrollbar section*/
.vb > .vb-dragger {
  z-index: 1;
  width: 6px;
  right: 0;
}
.vb > .vb-dragger > .vb-dragger-styler {
  backface-visibility: hidden;
  transform: rotate3d(0, 0, 0, 0);
  transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  background-color: rgb(199, 199, 199);
  margin: 5px 0px 5px 0;
  border-radius: 20px;
  height: calc(100% - 10px);
  display: block;
}
.vb.vb-scrolling-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgb(199, 199, 199);
}
.vb > .vb-dragger:hover > .vb-dragger-styler {
  background-color: rgb(199, 199, 199);
}
.vb.vb-dragging > .vb-dragger > .vb-dragger-styler {
  background-color: rgb(199, 199, 199);
}
.vb.vb-dragging-phantom > .vb-dragger > .vb-dragger-styler {
  background-color: rgb(199, 199, 199);
}
/*Scrollbar section*/
/*Map css*/
.map,
iframe,
.map-card {
  height: 100%;
  width: 100%;
  border: 0px;
}
/*New Indicator chip*/
.newindicator-chip {
  position: relative;
}
.newindicator-chip .input-group__selections {
  padding-right: 40px;
  z-index: 2;
}
.newindicator-chip .v-chip {
  position: absolute;
  top: 10px;
  right: 25px;
  z-index: 0;
}

.emergency-chip {
  padding-left: 1px;
  margin-left: 0;
}

.emergency-chip .v-avatar {
  margin-right: 3px;
  height: 22px !important;
  min-width: 22px !important;
  width: 22px !important;

  background-color: #fff !important;
  border-color: #fff !important;
}

.emergency-chip .v-avatar img {
  width: 15px !important;
  height: 15px !important;
  border-radius: 0px !important;
}

.v-toolbar__title {
  line-height: 1.3;
}
.enquiry-category-dialog .overlay--active:before {
  opacity: 0.23 !important;
}
/* Hide default scrollbar in dialog box */
.v-dialog::-webkit-scrollbar {
  display: none;
}

.speed-dial--absolute {
  z-index: 2 !important;
}

@media (max-width: 1264px) {
  .date-outer {
    margin-top: 10px;
  }
}
/*Middle section scroll in dialog box*/
.v-dialog .v-toolbar__content {
  padding: 0px 16px !important;
}
.v-dialog--scrollable {
  display: flex;
}
.v-dialog--scrollable .v-card {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
}
.v-dialog--scrollable .v-card .v-card__title,
.v-dialog--scrollable .v-card .v-card__actions,
.v-dialog--scrollable .v-card .v-toolbar--card {
  flex: 1 0 auto;
}
.v-dialog--scrollable .v-card .v-card__text {
  overflow-y: auto;
  backface-visibility: hidden;
}
.v-dialog--scrollable .scroll-content-dialog::-webkit-scrollbar {
  width: 7px;
}

.v-dialog--scrollable .scroll-content-dialog::-webkit-scrollbar-thumb {
  background-color: #c7c7c7;
  border-radius: 10px;
}
.newcustom-tooltip {
  max-width: 400px !important;
  z-index: 201 !important;
}
pre {
  font-family: inherit;
  white-space: pre-line;
}
.md-icon {
  font-size: 20px !important;
}
pre ol,
pre ul {
  padding-left: 20px;
}

/*Aling*/
.text-center {
  text-align: center !important;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}

/*Font Weight*/
.font-weight-thin {
  font-weight: 100 !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-regular {
  font-weight: 400 !important;
}
.font-weight-medium {
  font-weight: 500 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-black {
  font-weight: 900 !important;
}
.font-italic {
  font-style: italic !important;
}

/*img*/
.img-responsive {
  max-width: 100% !important;
}
.img-circle {
  border-radius: 50% !important;
}
.md-icon {
  font-size: 20px !important;
}
.card-box-shadow-none {
  box-shadow: none !important;
}

.v-input--selection-controls {
  margin-top: 4px;
}

.required label::after {
  content: '*';
}
/* NOTE: replacement for the above that removes the need for the class */
[aria-required='true'] label::after {
  content: '*';
}

.input-group__error {
  font-size: 12px;
  line-height: 12px;
  text-align: left;
}
.icon-validation .input-group__details {
  padding-left: 33px;
}
.v-window__container--is-active {
  height: 100% !important;
}
.v-messages__message {
  line-height: 1.8;
  padding-bottom: 2px;
}
.aling-center-chekbox .v-input--checkbox {
  padding-top: 10px;
  padding-top: 10px;
}
.aling-center-chekbox .v-input--checkbox .v-input__control {
  margin: 0 auto;
}
.aling-center-chekbox .v-input--checkbox .v-input__control .v-input__slot {
  margin-bottom: 0;
}
.aling-center-chekbox .v-input--checkbox .v-input__control .v-input__slot .v-input--selection-controls__input {
  margin-right: 0;
}

.v-menu__content .v-select-list .theme--light.v-list .v-list__group__header:hover,
.v-menu__content .v-select-list .theme--light.v-list .v-list__tile--highlighted,
.v-menu__content .v-select-list .theme--light.v-list .v-list__tile--link:hover {
  background: rgba(0, 0, 0, 0.12);
}

.theme--light.v-select .v-select__selections {
  color: inherit;
  font-size: 14px;
}

.v-text-field > .v-input__control > .v-input__slot {
  margin-bottom: 5px;
}

.v-carousel .v-image__image--cover {
  background-size: contain !important;
}
.v-carousel .v-carousel__next .v-btn,
.v-carousel .v-carousel__prev .v-btn {
  background-color: #bdbdbd;
}
.v-carousel .v-carousel__next .v-btn .v-icon,
.v-carousel .v-carousel__prev .v-btn .v-icon {
  font-size: 36px !important;
}
.v-window__container,
.v-window-item {
  height: 100% !important;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}
.mw-350 {
  max-width: 350px;
}
.second-toolbar {
  display: none;
}
.v-menu {
  display: inline;
}
.overflow-visible {
  overflow: visible !important;
}
.v-menu__content.v-autocomplete__content .v-select-list .v-subheader {
  font-weight: 600;
  font-size: 16px;
  background-color: #ffcdd2;
  color: #464646;
}
.v-menu__content.v-autocomplete__content .v-select-list .v-divider + .v-subheader {
  background-color: #c8e6c9;
}
.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
}

.hover-menu-content .hover-menu-item {
  display: none;
  position: absolute;
}
.hover-menu-content {
  position: relative;
  right: 0px;
}
.hover-menu-content:hover .hover-menu-item {
  display: block;
  position: absolute;
  right: 0px;
  top: 16px;
  text-align: center;
  /* left: 0px; */
  width: 250px;
  z-index: 2;
}
/*Sticky content*/
.claim-btn-content {
  position: fixed;
  left: 33.3%;
  right: 26.5%;
  bottom: 0px;
  background: #fff;
  padding: 10px 10px;
  z-index: 1;
}
.highlightText {
  background: yellow;
}
@media only screen and (max-width: 1440px) {
  .claim-btn-content .v-card__actions .v-btn__content {
    font-size: 12px;
  }
  .claim-btn-content {
    right: 26.9%;
  }
}
@media only screen and (max-width: 1300px) {
  .claim-btn-content {
    right: 25.3%;
    left: 38%;
  }
}
@media only screen and (max-width: 1299px) {
  .claim-btn-content .v-card__actions .v-btn {
    padding: 0 10px;
  }
  .claim-btn-content .v-card__actions .v-btn__content {
    font-size: 10px;
  }
}
@media only screen and (max-width: 1100px) {
  .claim-btn-content .v-card__actions .v-btn {
    padding: 0 4px;
  }
  .claim-btn-content {
    right: 25.8%;
  }
}

/* hide delete button from froala image manager  */
div.fr-modal-body div.fr-image-list div.fr-image-container .fr-delete-img {
  display: none !important;
}

div.fr-modal-body div.fr-image-list div.fr-image-container .fr-insert-img {
  -webkit-transform: translateY(-50%) translateX(-50%) !important;
  -moz-transform: translateY(-50%) translateX(-50%) !important;
  -ms-transform: translateY(-50%) translateX(-50%) !important;
  -o-transform: translateY(-50%) translateX(-50%) !important;
}

/* display notes */
pre.notes {
  display: inherit;
  font-family: inherit;
  word-break: break-all;
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
/* show deleted item as strikethrough */
.deleted-item {
  text-decoration: line-through;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
